import React, { useRef, useEffect } from 'react';
import styles from './index.module.less';
import { addEvent, removeEvent } from 'ava-util/dist/dom-event';
import { getWindowScrollTop } from 'ava-util/dist/dom-window';
import { addClass, removeClass } from 'ava-util/dist/dom-class';
import { useRouter } from 'next/router';

export type StickyHeaderProps = React.HTMLAttributes<HTMLDivElement> & {
    forceShow?: boolean;
    hideWhenDown?: boolean;
};

export const StickyHeader: React.FC<StickyHeaderProps> = props => {
    const router = useRouter();

    const containerRef = useRef<HTMLDivElement>(null);
    const affixRef = useRef<HTMLDivElement>(null);
    const stateRef = useRef<Record<string, any>>({
        record: 0,
    });
    const forceShowRef = useRef<boolean>(false);
    const { className, forceShow = false, hideWhenDown = false, children, ...rest } = props;

    const handleScroll = () => {
        const container = containerRef.current;
        const affix = affixRef.current;
        const state = stateRef.current;
        if (!container || !affix || forceShowRef.current) {
            return;
        }
        const sTop = getWindowScrollTop();
        if (container.getBoundingClientRect().top < 0) {
            addClass(affix, styles.sticky, false);
        } else {
            removeClass(affix, styles.sticky, false);
        }
        if (hideWhenDown) {
            const isScrollingDown = sTop > state.record;
            const isUnderAffixBottom = sTop > (container.offsetTop + affix.offsetHeight)
            if (isScrollingDown && isUnderAffixBottom) {
                addClass(affix, styles.down, false);
            } else {
                removeClass(affix, styles.down, false);
            }
            state.record = sTop;
        }
    };

    const handleResize = () => {
        const container = containerRef.current;
        const affix = affixRef.current;
        if (container && affix) {
            container.style.height = `${affix.offsetHeight}px`
        }

        handleScroll();
    };

    useEffect(() => {
        const container = containerRef.current;
        const affix = affixRef.current;
        if (container && affix) {
            container.style.height = `${affix.offsetHeight}px`
        }

        addEvent(window, 'resize', handleResize);
        if (!forceShow) {
            handleScroll();
            addEvent(window, 'scroll', handleScroll);
        }
        return () => {
            removeEvent(window, 'resize', handleResize)
            removeEvent(window, 'scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const affix = affixRef.current;
        if (forceShow && affix) {
            removeClass(affix, styles.down, false);
            forceShowRef.current = true;
        } else {
            forceShowRef.current = false;
        }
    }, [forceShow]);

    useEffect(() => {
        // path 变化执行一次 设置 containerRef 高度（）
        setTimeout(()=> {
            handleResize();
        }, 100)
    }, [router.pathname])

    return (
        <div ref={containerRef} id="js-sticky-header">
            <div
                ref={affixRef}
                className={className}
                {...rest}
            >
                {children}
            </div>
        </div>
    )
};